<template>
  <div class="page_box">
    <div class="page_option_box">
      <!-- 监控列表 -->
      <el-page-header
        @back="$Common.pageJump('/safety_inspection', 3)"
        content="摄像头列表"
      >
      </el-page-header>
      <el-button
        type="primary"
        plain
        size="mini"
        v-if="userInfo.roleId == -1"
        :disabled="monitorIds.length > 0 ? false : true"
        @click="pushMonitorsPower"
        >权限设置</el-button
      >
    </div>
    <div class="page_table_box">
      <div class="school_table_box" style="height:100%">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center"
          ></el-table-column>
          <el-table-column prop="monitorId" label="监控ID" align="center">
          </el-table-column>
          <el-table-column prop="monitorName" label="监控名称" align="center">
            <template slot-scope="rowData">
              <span v-if="!rowData.row.isEdit">{{
                rowData.row.monitorName
              }}</span>
              <el-input
                v-else
                style="width:95%"
                v-model.trim="rowData.row.monitorName"
                placeholder="请输入监控名称"
                clearable
                size="small"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="deviceNum" label="设备编号" align="center">
          </el-table-column>
          <el-table-column label="状态" width="120" align="center">
            <template slot-scope="rowData">
              <el-tag type="success" v-if="rowData.row.status == 0"
                >启用</el-tag
              >
              <el-tag type="warning" v-else>禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="rowData">
              <div v-if="rowData.row.isEdit">
                <el-link
                  class="link_box"
                  type="primary"
                  :underline="false"
                  @click="setMonitorName(rowData.row)"
                  >保存</el-link
                >
                <el-divider direction="vertical"></el-divider>
                <el-link
                  class="link_box"
                  type="primary"
                  :underline="false"
                  @click="cencelOption(rowData.row)"
                  >取消</el-link
                >
              </div>
              <div v-else class="more-option-box">
                <el-link
                  class="link_box"
                  type="primary"
                  :underline="false"
                  v-if="rowData.row.status == 0"
                  @click="operate(1, rowData.row.monitorId)"
                  >禁用</el-link
                >
                <el-link
                  class="link_box"
                  type="primary"
                  :underline="false"
                  size="mini"
                  v-if="rowData.row.status == 1"
                  @click="operate(0, rowData.row.monitorId)"
                  >启用</el-link
                >
                <el-divider direction="vertical"></el-divider>
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      更多<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item class="dropdown_item_box"
                        ><el-link
                          class="link_box"
                          type="primary"
                          :underline="false"
                          :disabled="editOption"
                          @click="openEditBox(rowData.row)"
                          >编辑</el-link
                        ></el-dropdown-item
                      >
                      <el-dropdown-item class="dropdown_item_box"
                        ><el-link
                          class="link_box"
                          type="primary"
                          :underline="false"
                          size="mini"
                          v-if="userInfo.roleId != -1"
                          @click="getMonitorsPower(rowData.row)"
                          >访问权限</el-link
                        ></el-dropdown-item
                      >
                      <el-dropdown-item class="dropdown_item_box"
                        ><el-link
                          class="link_box"
                          type="primary"
                          :underline="false"
                          size="mini"
                          @click="monitorsInstall(rowData.row)"
                          >视频设置</el-link
                        ></el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <monitors-install :cameraInfo='cameraInfo' :showOpen="showOpen" @close="mClose"></monitors-install>
  </div>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
import monitorsInstall from "./components/monitorsInstall";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    monitorsInstall
  },
  props: {},
  data() {
    //这里存放数据
    return {
      tableData: [],
      monitorIds: [],
      editOption: false,
      showOpen: false,
      cameraInfo: {}
    };
  },
  //监控data中的数据变化
  watch: {},
  //计算属性，类似于data概念
  computed: {
    userInfo() {
      return JSON.parse(sessionStorage.getItem("userInfo"));
    }
  },
  //方法集合
  methods: {
    async getCameraList() {
      console.log(this.$route.query);
      let req = { deviceNum: this.$route.query.deviceNum };
      let res = await this.$Http.getCameraList(req);
      this.editOption = false;
      if (res.code == 200) {
        let data = res.data || [];
        this.tableData = data.map((item, index) => {
          item.isEdit = false;
          return item;
        });
      } else if (res.code == 101) {
        this.tableData = [];
      } else {
        this.tableData = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    getMonitorsPower(row) {
      this.monitorIds = [row.monitorId];
      this.pushMonitorsPower();
    },
    handleSelectionChange(val) {
      this.monitorIds = val.map((item, index) => {
        return item.monitorId || "";
      });
    },
    pushMonitorsPower() {
      let ids = this.monitorIds.join(",");
      this.$Common.pageJump("/monitors_power_info?monitorId=" + ids, 3);
    },
    // 编辑通道状态
    async operate(num, id) {
      let req = {
        monitorId: id,
        status: num
      };
      let res = await this.$Http.modifyMonitorStatus(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "编辑成功！"
        });
        this.getCameraList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 打开编辑框
    openEditBox(info) {
      info.isEdit = true;
      this.editOption = true;
    },
    cencelOption() {
      this.getCameraList();
    },
    // 修改通道名称
    async setMonitorName(info) {
      if (!info.monitorName) {
        this.$message({
          type: "warning",
          message: "请输入监控通道名称！"
        });
        return;
      }
      var newParamData = {
        deviceNum: info.deviceNum, // 设备序列号
        monitorId: info.monitorId, // 监控id
        channelNo: info.monitorChannel, // 通道号
        name: info.monitorName // 通道名称
      };
      let res = await this.$Http.setMonitorName(newParamData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.getCameraList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 摄像头设置
    monitorsInstall(info) {
      console.log(info, "-----------");
      this.cameraInfo = {
        deviceSerial: info.deviceNum,
        channlNo: info.monitorChannel
      };
      this.showOpen = true;
    },
    mClose() {
      this.showOpen = false;
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {
    this.getCameraList();
  },
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.more-option-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
